<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oIz1Mf/tc-custom/9781488016431.jpg?1699984883772" alt="This image is the cover for the book Stranger She Can Trust, Escape Club Heroes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stranger She Can Trust, Escape Club Heroes
      </h1>
      <p class="bookDescription body article font2">
        <b>In the <i>USA Today</i>–bestselling author’s sexy romantic thriller, a paramedic with a dark past builds a future with a woman who lost her memory.</b><br/><br/>Outside of one of Philadelphia’s busiest nightclubs, a woman stumbles from her taxi. Beaten and bruised, Melissa Baxter is an amnesiac with a target on her back. Gun-shy, Melissa must rely on a handsome hero to help her uncover who she really is. <br/><br/>A paramedic with his own dark history, Carson Lane can’t help but bring this beautiful, vulnerable woman under his wing. Still reeling from his partner’s murder, he’s no stranger to risk. But as he and Melissa begin unraveling the mystery of who she really is, Carson realizes falling in love could be the biggest risk of all.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Regan Black
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20194444